import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';

import { ChipModule } from 'primeng/chip';
import { MultiSelectModule } from 'primeng/multiselect';

import { CommonBaseComponent } from '../common-base.component';

@Component({
  selector: 'app-multiselect',
  templateUrl: './multiselect.component.html',
  styleUrls: ['./multiselect.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,

    ChipModule,
    MultiSelectModule,
  ],
})
export class MultiSelectComponent extends CommonBaseComponent {
  @Input() placeholder: string = 'SELECT';
  @Input() selectedItem: any;

  constructor() {
    super();
  }

  onRemove(item: any) {
    const field = this.form.controls[this.item.key];

    field.setValue(field.value.filter((i: any) => i !== item));
  }

  getChipLabel(item: any) {
    return this.item.options?.find((i: any) => i.value === item)?.label || '';
  }
}
